var unirest = require("unirest");
const API = require("Api");

export async function getCollection(token, calendarID, collection) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };
  if (collection.useCalendar) {
    headers.crrntcal = calendarID;
  }

  const res = await unirest
    .get(collection.endpoint)

    .headers(headers);

  let list = [];
  if (res.error) console.log(res.error);
  else list = res.body;
  return list;
}

export async function updateParameter(token, param_id, data) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };

  const res = await unirest
    .patch(API.V2 + API.CONFIG + "params/" + param_id)
    .headers(headers)
    .send(data);

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getCommits() {
  const res = await unirest
    .get("https://api.github.com/repos/babeligo/alumni-web-app2/commits")
    .headers({ "Content-Type": "application/json" })
    .auth({
      user: "giulifed",
      pass: "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",
    });

  if (res.error) {
    return { error: "No pude obtener las ultimas actualizaciones" };
  }
  let list = res.body;
  return list;
}

export async function getSysUsers(token) {
  const res = await unirest.get(API.V2 + "config/sysusers").headers({
    // const res = await unirest
    //   .get("http://0.0.0.0:3005/" + "config/sysusers")
    //   .headers({
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getKpis(token) {
  const res = await unirest.get(API.V2 + "config/kpis").headers({
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getUserDashboard(token) {
  const res = await unirest.get(API.V2 + "config/dashboard").headers({
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function updateAllTags(token, personaID, tagID, newStatus) {
  const res = await unirest
    .put(API.V2 + "personas/" + personaID + "/tags/" + tagID)
    .headers({
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    })
    .send({ status: newStatus });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getNewProfilePhotos(token) {
  const res = await unirest.get(API.V2 + "personas/newProfilePhotos").headers({
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getLevels(token, calendarID, parentID) {
  const res = await unirest
    .get(API.V2 + "levels" + (parentID != null ? "/" + parentID : ""))
    .headers({
      Authorization: "Bearer " + token,
      crrntcal: calendarID,
      "Content-Type": "application/json",
    });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getEvaluations(token, levelID) {
  const res = await unirest
    .get(API.V2 + "levels/" + levelID + "/evals")
    .headers({
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getSubjectLevels(token, levelID) {
  const res = await unirest
    .get(API.V2 + "levels/" + levelID + "/subjects")
    .headers({
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    });

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function updateEvaluation(token, levelID, evaluationID, data) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };
  const res = await unirest
    .patch(API.V2 + "levels/" + levelID + "/evals/" + evaluationID)
    .headers(headers)
    .send(data);

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function createEvaluation(token, data) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };
  const res = await unirest
    .post(API.V2 + "levels/" + data.level_id + "/evals")
    .headers(headers)
    .send(data);

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function updateSubjectLevels(
  token,
  levelID,
  subjectID,
  data,
  populate
) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };
  if (populate) headers.populate = populate;

  const res = await unirest
    .put(API.V2 + "levels/" + levelID + "/subjects/" + subjectID)
    .headers(headers)
    .send(data);

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function deleteSubjectLevels(token, levelID, subjectID) {
  let headers = {
    Authorization: "Bearer " + token,
    "Content-Type": "application/json",
  };

  const res = await unirest
    .delete(API.V2 + "levels/" + levelID + "/subjects/" + subjectID)
    .headers(headers);

  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}
